export const COLUMN_STYLES = {
    pending: "border-t-yellow-600/40",
    running: "border-t-blue-600/40",
    completed: "border-t-green-600/40",
    failed: "border-t-red-600/40",
};

export const COUNT_STYLES = {
    pending: "bg-yellow-50 text-yellow-700",
    running: "bg-blue-50 text-blue-700",
    completed: "bg-green-50 text-green-700",
    failed: "bg-red-50 text-red-700",
};
